import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const CompanyId = z.coerce.number().int().positive();
const SubmissionId = z.coerce.number().int().positive();
const QuestionId = z.coerce.number().int().positive();
const SuccessResponse = z.object({ success: z.boolean() });
export const postCommentProjectSubmissionRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/submissions/comment',
    name: 'post-comment-project-submission',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({ submissionId: SubmissionId, comment: z.string() }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const reviewSubmissionRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/submissions/review',
    name: 'review-submission',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({
            submissionId: SubmissionId,
            type: z.enum(['ACTIVITY', 'PROJECT']),
            review: z.string(),
            questionId: QuestionId,
        }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
const OfficeHourNotes = z.object({
    goals: z.string(),
    challenges: z.string(),
    insights: z.string(),
});
export const saveOfficeHoursNotesRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/office-hours/notes',
    name: 'save-office-hours-notes',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({
            learners: z.array(z.object({
                offficeHourNoteId: z.coerce.number().int().positive(),
                didAttend: z.boolean(),
                notes: OfficeHourNotes,
            })),
        }),
    },
    responses: { 200: SuccessResponse },
};
